export default class DtoTankZone {
    constructor(obj) {
        this.idStation = obj.idStation
        this.code = obj.code
        this.stateCode = obj.stateCode
        this.comment = obj.comment
    }
}